import React, { useState } from "react";
import { motion } from "framer-motion";

const ApprovalSettings = () => {
  const [form, setForm] = useState({
    expenseType: "sequence",
    leaveType: "sequence",
    offerType: "sequence",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Approval Settings
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        <div className="card-body">

          {/* SECTION TEMPLATE */}
          {[
            { title: "Expense Approval", key: "expenseType" },
            { title: "Leave Approval", key: "leaveType" },
            { title: "Offer Approval", key: "offerType" },
          ].map((section, index) => (
            <motion.div
              key={section.key}
              className="mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <p className="fw-semibold mb-2">{section.title}</p>

              <div className="row align-items-center mb-2">
                <div className="col-md-4">
                  <small>Default Approval Type</small>
                </div>

                <div className="col-md-8 d-flex gap-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={section.key}
                      value="sequence"
                      checked={form[section.key] === "sequence"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label small">
                      Sequence Approve
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={section.key}
                      value="simultaneous"
                      checked={form[section.key] === "simultaneous"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label small">
                      Simultaneous
                    </label>
                  </div>
                </div>
              </div>

              {section.key !== "offerType" && (
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <small>{section.title.split(" ")[0]} Approver</small>
                  </div>

                  <div className="col-md-4">
                    <motion.select
                      className="form-select form-select-sm"
                      whileFocus={{ scale: 1.02 }}
                    >
                      <option>----- Select -----</option>
                      <option>Manager</option>
                      <option>HR</option>
                    </motion.select>
                  </div>
                </div>
              )}

              {index !== 2 && <hr />}
            </motion.div>
          ))}

          {/* FOOTER */}
          <motion.div
            className="d-flex justify-content-end mt-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <motion.button
              whileTap={{ scale: 0.9 }}
              className="btn btn-outline-secondary btn-sm me-2"
            >
              Cancel
            </motion.button>

            <motion.button
              whileTap={{ scale: 0.9 }}
              className="btn btn-outline-primary btn-sm"
            >
              Save
            </motion.button>
          </motion.div>

        </div>
      </motion.div>
    </motion.div>
  );
};

export default ApprovalSettings;